import { toggleModal } from './modal';
export function initCustomFieldRulesDisplay(typeSelector) {
  const type = document.querySelector(typeSelector);

  type.addEventListener('change', function () {
	switchRulesState(type.value);
  });

  document.addEventListener('DOMContentLoaded', function () {
	switchRulesState(type.value);
  })
}
function switchRulesState(value) {
  const min = document.querySelector('#min');
  const max = document.querySelector('#max');
  const step = document.querySelector('#step');
  const format = document.querySelector('#format');
  const multiple = document.querySelector('#multiple');
  const list = document.querySelector('#list');
  const plugins = document.querySelector('#plugins');

  switch (value) {
	case 0:
	case "0":
	case "Text":
	  min.classList.remove('hidden');
	  max.classList.remove('hidden');
	  step.classList.add('hidden');
	  format.classList.add('hidden');
	  multiple.classList.add('hidden');
	  list.classList.add('hidden');
	  plugins.classList.add('hidden');
	  break;
	case 1:
	case "1":
	case "Textarea":
	  min.classList.remove('hidden');
	  max.classList.remove('hidden');
	  step.classList.add('hidden');
	  format.classList.add('hidden');
	  multiple.classList.add('hidden');
	  list.classList.add('hidden');
	  plugins.classList.add('hidden');
	  break;
	case 2:
	case "2":
	case "Date":
	  min.classList.add('hidden');
	  max.classList.add('hidden');
	  step.classList.add('hidden');
	  format.classList.remove('hidden');
	  multiple.classList.add('hidden');
	  list.classList.add('hidden');
	  plugins.classList.add('hidden');
	  break;
	case 3:
	case "3":
	case "Choice":
	  min.classList.add('hidden');
	  max.classList.add('hidden');
	  step.classList.add('hidden');
	  format.classList.add('hidden');
	  multiple.classList.remove('hidden');
	  list.classList.remove('hidden');
	  plugins.classList.add('hidden');
	  break;
	case 4:
	case "4":
	case "Number":
	  min.classList.remove('hidden');
	  max.classList.remove('hidden');
	  step.classList.remove('hidden');
	  format.classList.add('hidden');
	  multiple.classList.add('hidden');
	  list.classList.add('hidden');
	  plugins.classList.add('hidden');
	  break;
	case 5:
	case "5":
	case "Image":
	  min.classList.add('hidden');
	  max.classList.add('hidden');
	  step.classList.add('hidden');
	  format.classList.add('hidden');
	  multiple.classList.add('hidden');
	  list.classList.add('hidden');
	  plugins.classList.add('hidden');
	  break;
	case 6:
	case "6":
	case "DocumentSection":
	  min.classList.add('hidden');
	  max.classList.add('hidden');
	  step.classList.add('hidden');
	  format.classList.add('hidden');
	  multiple.classList.add('hidden');
	  list.classList.add('hidden');
	  plugins.classList.remove('hidden');
	  break;
	default:
	  min.classList.add('hidden');
	  max.classList.add('hidden');
	  step.classList.add('hidden');
	  format.classList.add('hidden');
	  multiple.classList.add('hidden');
	  list.classList.add('hidden');
	  break;
  }
}

document.addEventListener('DOMContentLoaded', function () {
  initCustomFieldsSelectionModal();
});

function initCustomFieldsSelectionModal() {
  const customFieldsSelectionModal = document.querySelector('#customFieldsSelection-modal');
  if (!customFieldsSelectionModal)
	return;

  


  const tableOptions = {
	ajaxURL: '/Templates/CustomFields/list/?handler=TabulatorList',
	initialSort: [{ column: 'name', dir: 'asc' }],
	paginationSize: 10,
	paginationSizeSelector: [10],
	persistence: {
	  sort: true,
	  filter: false,
	  headerFilter: false,
	  group: false,
	  page: false,
	  columns: false,
	},
	columns: [
	  {
		title: 'Nome', field: 'name',
		headerFilter: 'input',
		responsive: 0
	  },
	  {
		title: 'Livello', field: 'customFieldLevel',
		headerFilter: 'list', headerFilterParams: { values: customFieldLevelSli }, headerSort: false, width: 150
	  },
	  {
		title: 'Tipo', field: 'customFieldType',
		headerFilter: 'list', headerFilterParams: { values: customFieldTypeSli }, headerSort: false, width: 150
	  },
	  {
		title: '', field: 'id', width: 150,
		headerFilter: false, headerSort: false,
		formatter: 'select-button'
	  }
	]
  };

  let customFieldsSelectionTable;

  customFieldsSelectionModal.addEventListener('modal.show', (event) => {

	tableOptions.initialHeaderFilter = [
	  { field: 'name', value: customFieldName },
	  { field: 'customFieldType', value: customFieldType }
	];

	customFieldsSelectionTable = app.tabulator.init('#customFieldsSelection-table', tableOptions);

	customFieldsSelectionTable.on('dataProcessed', function () {
	  customFieldsSelectionModal
		.querySelectorAll('[data-select-button]')
		.forEach((btn) => {
		  btn.addEventListener('click', (event) => {
			let customEvent = new CustomEvent('customfieldselected',
			  {
				bubbles: true,
				detail: {
				  status: 'SELECTED',
				  customFieldId: event.currentTarget.dataset.selectButton
				}
			  });
			document.dispatchEvent(customEvent);
			toggleModal(customFieldsSelectionModal);
		  });
		});
	});
  });

  customFieldsSelectionModal.addEventListener('modal.hide', function (event) {
	let customEvent = new CustomEvent('customfieldselected',
	  {
		bubbles: true,
		detail: { status: 'CANCELED' }
	  });
	document.dispatchEvent(customEvent);
	customFieldsSelectionTable.destroy();
  });

}